import { render } from "./PaywallNav.vue?vue&type=template&id=96bf9744&scoped=true"
import script from "./PaywallNav.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallNav.vue?vue&type=script&setup=true&lang=js"

import "./PaywallNav.vue?vue&type=style&index=0&id=96bf9744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96bf9744"],['__file',"src/components/Paywall/PaywallNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96bf9744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96bf9744', __exports__)) {
    api.reload('96bf9744', __exports__)
  }
  
  module.hot.accept("./PaywallNav.vue?vue&type=template&id=96bf9744&scoped=true", () => {
    api.rerender('96bf9744', render)
  })

}


export default __exports__